import { LeadNoteContent, LeadNoteDetails } from '.';
import * as classNames from 'classnames';
import { EVisibility, ILeadNote } from 'common/interfaces/provider';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import isNil from 'lodash-es/isNil';
import * as moment from 'moment';

// Styles
const s = require('../LeadNotes.css');

//Props
export interface ILeadNoteProps extends IAppOnlyStore {
  noteInfo: ILeadNote;
  index: number;
}

// Component
@inject('store')
@observer
export class LeadNote extends React.Component<ILeadNoteProps, {}> {
  @computed private get isHidden(): boolean {
    return this.props.noteInfo.hidden === EVisibility.Hidden;
  }

  @computed private get isCreator(): boolean {
    const { noteInfo, store } = this.props;
    return Boolean(
      store.user.id === noteInfo.createdByUser.id ||
        store.user.id === noteInfo.updatedByUser.id
    );
  }

  @computed private get authorName(): string {
    const { updatedByUser, createdByUser } = this.props.noteInfo;

    if (!isNil(updatedByUser) && !isNil(updatedByUser.name)) {
      return updatedByUser.name;
    } else if (!isNil(createdByUser) && isNil(createdByUser.name)) {
      return createdByUser.name;
    } else {
      return '';
    }
  }

  @computed private get lastDate(): moment.Moment | null {
    const { updatedAt, createdAt } = this.props.noteInfo;

    if (!isNil(updatedAt)) {
      const updatedAtParsed = moment(updatedAt);
      return updatedAtParsed.isValid() ? updatedAtParsed : null;
    } else if (!isNil(createdAt)) {
      const createdAtParsed = moment(createdAt);
      return createdAtParsed.isValid() ? createdAtParsed : null;
    } else {
      return null;
    }
  }

  @computed private get lastTimeFormat(): string {
    return this.lastDate !== null ? this.lastDate.format('h:mm A') : '';
  }

  public render() {
    const { noteInfo, index } = this.props;

    return noteInfo.id &&
      (!this.isHidden || (this.isHidden && this.isCreator)) ? (
      <div
        className={classNames(s.note, {
          [s.hidden]: this.isHidden,
          [s.odd]: index % 2 === 0,
          [s.even]: index % 2 > 0,
        })}
      >
        <div className={s.noteSummary}>
          {this.authorName && <p className={s.name}>{this.authorName}</p>}

          {this.lastTimeFormat && (
            <p className={s.time}>{this.lastTimeFormat}</p>
          )}
        </div>

        <div className={s.noteContent}>
          <LeadNoteContent noteInfo={noteInfo} />
        </div>

        <LeadNoteDetails noteInfo={noteInfo} />
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Notes/Note/LeadNote.tsx